import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FiUser } from 'react-icons/fi';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';


const LoginForm = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    remember: false,
  });

  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const validationErrors = {};
  
    if (!formData.email) {
      validationErrors.email = "Email is required.";
    } else if (!validateEmail(formData.email)) {
      validationErrors.email = "Please enter a valid email address.";
    }
  
    if (!formData.password) {
      validationErrors.password = "Password is required.";
    }
  
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
  

    login(); 
  
   
    toast.success('Login successful!', {
      className: 'custom-toast success-toast',
    });
  

    setTimeout(() => {
      navigate('/');
    }, 2000);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className="login-box">
        <div className="login-logo">
          <img src={logo} alt="Logo" className="logo-image" />
        </div>
        <h2>Sign in</h2>
        <p>Don't have an account? <Link to="/signup">Create new!</Link></p>
        <Form onSubmit={handleLogin} className="form login-form">

          {/* Email Field */}
          <Form.Group className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="text"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              isInvalid={!!errors.email}
            />
            <Form.Control.Feedback type="invalid" className="d-block">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          {/* Password Field with Eye Icon */}
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <div style={{ position: 'relative' }}>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                isInvalid={!!errors.password}
              />
              <div
                onClick={togglePasswordVisibility}
                className="eye-icon"
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: '12px',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#666'
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>
            <Form.Control.Feedback type="invalid" className="d-block">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>

          {/* Remember me + Forgot password */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <Form.Check
              type="checkbox"
              label="Remember me"
              name="remember"
              checked={formData.remember}
              onChange={handleChange}
              className="custom-remember-checkbox"
            />
            <Link to="/forgot-password" className="forgot-password">
              Forgot your password?
            </Link>
          </div>

          {/* Submit Button */}
          <Button type="submit" className="full-btn sign-in-btn w-100">
            <FiUser className="me-1" /> Sign In
          </Button>
        </Form>
      </div>
    </>
  );
};

export default LoginForm;
